import { render, staticRenderFns } from "./TabEnderecos.vue?vue&type=template&id=e61085f2"
import script from "./TabEnderecos.vue?vue&type=script&lang=js"
export * from "./TabEnderecos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports